// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___bWLgd","title":"style__title___37h-a","benefits":"style__benefits___3p-QW","closeBtnWrap":"style__closeBtnWrap___C0O7k","closeBtn":"style__closeBtn___vCG-6"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/layout/ui/components/modal-goapp/style.css
// module id = 1114
// module chunks = 0